import { motion } from "~/utils";
import { Meaple } from "~/business";
import { usePlayerColor } from "~/jsx/hook/usePlayerColor";
import { Colors } from "~/jsx/theme";
import { ZIndex } from "~/jsx/theme/ZIndex";
import { XMeapleSlotSvg } from "./svg";
import { XMeapleSvg } from "./svg";

export const XMeaple = ({
  meaple,
  width = 36,
  noAnimation = false,
}: {
  meaple?: Meaple;
  width?: number;
  noAnimation?: boolean;
}) => {
  return (
    <div
      style={{
        position: "relative",
        width,
        height: width,
        display: "inline-block",
        zIndex: ZIndex.meaple,
      }}
    >
      <div style={{ position: "absolute", top: 0, left: 0 }}>
        <XMeapleSlotSvg width={width} />
      </div>
      {meaple && (
        <div style={{ position: "absolute", top: 0, left: 0 }}>
          <PlayerMeaple
            meaple={meaple}
            width={width}
            noAnimation={noAnimation}
          />
        </div>
      )}
    </div>
  );
};

const PlayerMeaple = ({
  meaple,
  width,
  noAnimation,
}: {
  meaple: Meaple;
  width: number;
  noAnimation?: boolean;
}) => {
  const color = usePlayerColor(meaple.owner) ?? Colors.common.black;
  return (
    <motion.div {...(noAnimation ? {} : { layoutId: meaple.id })}>
      <XMeapleSvg width={width} color={color} />
    </motion.div>
  );
};
